import { PaymentAccountOverdraftStoreService } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'payment-account-overdraft-amount',
    imports: [ApAmountInputComponent, NextButtonComponent, ReactiveFormsModule, CoApplicantPipe, ApContentPipe, AdditionalInfoComponent],
    templateUrl: './payment-account-overdraft-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PaymentAccountOverdraftStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PAYMENT_ACCOUNT_OVERDRAFT_AMOUNT }
    ]
})
export class PaymentAccountOverdraftAmountComponent extends GlobalInjectComponent<PaymentAccountOverdraftStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PaymentAccountOverdraftStoreService);

    constructor() {
        super();
    }

    ngOnInit() {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getTotalCreditAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setTotalCreditAmount(amount));
    }
}
